module.exports = __webpack_public_path__ + "img/Flag_of_Denmark.07be1277.svg";